// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","countryFlag":"countryFlags_countryFlag__x3Hnp"};